import { render } from "./ApartmentsBudget.vue?vue&type=template&id=17e797c8"
import script from "./ApartmentsBudget.vue?vue&type=script&lang=js"
export * from "./ApartmentsBudget.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__